import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Pre } from '@r1-frontend/ui-react/components/typography/formatting';
import { H2, H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { BlockContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';

export const History = styled.section`
    width: 100%;
    margin-bottom: 96px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 64px;
    }
`;

export const SBlockContainer = styled(BlockContainer)`
    display: grid;
    grid-template-columns: 0.3fr 1fr;
    grid-template-rows: repeat(auto-fill, 52px);
    grid-template-areas: 'img title' 'img text';
    column-gap: 56px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        align-items: center;
        grid-template-rows: auto;
        grid-template-areas: 'img title' 'text text';
        gap: 16px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-template-columns: 1fr;
        grid-template-areas: 'img' 'title' 'text';
        gap: 12px;
    }
`;

export const ButtonText = styled(H3)<{customColor: string}>`
    color: ${({ customColor }) => customColor};
`;

export const SH2 = styled(H2)`
    grid-area: title;
`;

export const SPre = styled(Pre)`
    grid-area: text;
`;

export const ImageWrapper = styled(RounderContainer)`
    grid-area: img;
    height: 200px;
    width: 320px;

    img, picture {
        display: block;
        height: auto;
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 160px;
        width: 256px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: auto;
        margin: -16px -16px 0;
        width: calc(100% + 32px);
        margin-bottom: 12px;
    }
`;
